import { API_URL, baseURL } from "../../../../utils/constant";
import { APIError, handleAPIError } from "../../../common/errorHandler";
import { getDecoratedUrl } from "../../../common/urlService";
import { getApiAsyn } from "../../../PostAPI";
import axios from "axios";

export const fetchCompanies = async (payload) => {
  const url = getDecoratedUrl({
    url: API_URL.SYSTEM_COMPANIES.GET,
    payload,
  });
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }
    return result || [];
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchCompaniesById = async (payload) => {
  const url = API_URL.SYSTEM_COMPANIES.GET_BY_ID.replace(":id", payload?.id);
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

const dataApi = (url, data, isEdit = false) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };

  if (isEdit) {
    return axios.put(baseURL + url, data, config);
  }
  return axios.post(baseURL + url, data, config);
};

export const createCompanies = async (payload) => {
  try {
    let result = await dataApi(API_URL.SYSTEM_COMPANIES.CREATE, payload, false);
    if (result?.data?.error) {
      throw new APIError(result.data);
    }
    return result.data;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const editCompanies = async (payload) => {
  const url = API_URL.SYSTEM_COMPANIES.EDIT.replace(":id", payload.id);
  try {
    let result = await dataApi(url, payload.data, true);
    if (result?.data?.error) {
      throw new APIError(result.data);
    }
    return result.data;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const deleteCompanies = async (payload) => {
  const url = API_URL.SYSTEM_COMPANIES.DEACTIVATE.replace(":id", payload.id);
  try {
    let result = await dataApi(url, {}, false);
    if (result?.data?.error) {
      throw new APIError(result.data);
    }
    return result.data;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};
